import { render, staticRenderFns } from "./ScrollDownButton.vue?vue&type=template&id=09f17151&scoped=true&"
import script from "./ScrollDownButton.vue?vue&type=script&lang=ts&"
export * from "./ScrollDownButton.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollDownButton.vue?vue&type=style&index=0&id=09f17151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f17151",
  null
  
)

export default component.exports